import React, { useState } from "react";
import { Grid, IconButton, Typography } from "@mui/material";
// import Fib from "../Images/Footer/fib.png";
// import Vise from "../Images/Footer/visa.png";
// import MAster from "../Images/Footer/mastercard.512x329.png";
import { Link } from "react-router-dom";
import instagram from "../Images/instagram.png";
import Whatsapp from "../Images/apple.png";
import Gmail from "../Images/gmail.png";
import Facebook from "../Images/facebook.png";
import FoterLogo from "../Images/Footer/15.jpg";

const Footer = () => {
  const [showTransport] = useState(false);

  return (
    <footer>
      <Grid
        container
        spacing={2}
        justifyContent="space-between"
        alignItems="flex-start"
        sx={{
          backgroundColor: "#FAFBFB",
          padding: "20px",
          color: "black",
          fontSize: "1.4rem",
          "@media (max-width: 600px)": {
            fontSize: "1rem", // Adjust font size for mobile screens
          },
        }}
      >
        {/* Column 1 */}
        <Grid item xs={12} sm={6}>
          <ul>
            <div>
              <img
                src={FoterLogo}
                alt="Logo"
                height={66}
                width={220}
                style={{
                  borderRadius: "20%",
                }}
              />
            </div>
            {/* <div>UK TO MARS LTD - Headquarters(UK)</div>
            <div>15 Little Balmer</div>
            <div>Buckingham Industrial Estate, Buckingham,</div> */}
            {/* Address: 15 Little Balmer, Buckingham Industrial Estate, Buckingham,
            MK18 1TF, UK */}
            <div>15 Little Balmer, Buckingham Industrial Estate,</div>
            {/* <div> Buckingham Industrial Estate</div> */}
            <div>Buckingham, MK18 1TF, UK</div>

            <div style={{ display: "inline-flex", alignItems: "center" }}>
              Email:
              <a
                href="mailto:admin@uktomars.co.uk "
                style={{
                  marginLeft: "5px",
                  textDecoration: "none",
                  color: "blue",
                }}
              >
                admin@uktomars.co.uk
              </a>
            </div>
            <br />
            <div style={{ display: "inline-flex", alignItems: "center" }}>
              Email:
              <a
                href="mailto:info@uktomars.co.uk"
                style={{
                  marginLeft: "5px",
                  textDecoration: "none",
                  color: "blue",
                }}
              >
                info@uktomars.co.uk
              </a>
            </div>
            {showTransport && <div>Transport: WhatsApp</div>}
            <br />
            <div style={{ display: "inline-flex", alignItems: "center" }}>
              UK:
              <img
                src={Whatsapp}
                alt="WhatsApp"
                height={20}
                width={20}
                style={{ margin: "0 5px" }}
              />
              +44 7564 627910
            </div>

            {/* <div style={{ display: "inline-flex", alignItems: "center" }}>
              Iraq:
              <img
                src={Whatsapp}
                alt="WhatsApp"
                height={20}
                width={20}
                style={{ margin: "0 5px" }}
              />
              004475600964
            </div> */}
          </ul>
        </Grid>

        {/* Column 2 */}
        {/* <Grid item xs={12} sm={3} sx={{ marginTop: "80px" }}> */}
        {/* <Grid item xs={12} sm={3}>
         
         
          <ul>
            <div>
              <img
                src={FoterLogo}
                alt="Logo"
                height={66}
                width={220}
                style={{
                  borderRadius: "20%",
                }}
              />
            </div>
            <div>UK TO MARS LTD - Iraq Branch</div>
            <div>94-1/7094, Farmanbaran,</div>
            <div style={{ display: "inline-flex", alignItems: "center" }}>
              Email:
              <a
                href="mailto:info@uktomars.co.uk"
                style={{
                  marginLeft: "5px",
                  textDecoration: "none",
                  color: "blue",
                }}
              >
                info@uktomars.co.uk
              </a>
            </div>
            <div>Erbil, Iraq, 44001</div>
            {showTransport && <div>Transport: WhatsApp</div>}

            <div style={{ display: "inline-flex", alignItems: "center" }}>
              Iraq:
              <img
                src={Whatsapp}
                alt="WhatsApp"
                height={20}
                width={20}
                style={{ margin: "0 5px" }}
              />
              +964 772 807 7272
            </div>
          </ul>
        </Grid> */}
        {/* Column 3 */}
        <Grid
          item
          xs={12}
          sm={3}
          sx={{
            // Applies 90px margin only on medium (md) breakpoint and up
            marginTop: { md: "70px" },
            // Reset margin on smaller screens
            "@media (max-width: 959.95px)": {
              marginTop: 0,
            },
          }}
        >
          <ul>
            <div>
              <Typography variant="h6" gutterBottom>
                Legal
              </Typography>
            </div>
            <div>
              <Link
                to="/PrivacyPolicy"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Privacy policy
              </Link>
            </div>
            <div>
              <Link
                to="/TermsAndConditions"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Terms and conditions
              </Link>
            </div>
          </ul>
        </Grid>

        {/* Social Media Icons */}

        <Grid
          item
          xs={12}
          sm={3}
          sx={{
            // Applies 90px margin only on medium (md) breakpoint and up
            marginTop: { md: "80px" },
            // Reset margin on smaller screens
            "@media (max-width: 959.95px)": {
              marginTop: 0,
            },
          }}
        >
          <div
            style={{
              marginLeft: "auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <IconButton
              href="https://www.instagram.com/uk_to_mars"
              target="_blank"
            >
              <img src={instagram} alt="Instagram" height={25} width={25} />
            </IconButton>
            <IconButton href="http://wa.me/447564627910" target="_blank">
              <img src={Whatsapp} alt="WhatsApp" height={25} width={25} />
            </IconButton>
            <IconButton href="mailto:info@uktomars.co.uk" target="_blank">
              <img src={Gmail} alt="Gmail" height={25} width={25} />
            </IconButton>
            <IconButton
              href="https://www.facebook.com/share/15wM7LKkfg"
              target="_blank"
            >
              <img src={Facebook} alt="Facebook" height={25} width={25} />
            </IconButton>
          </div>
          <Typography
            variant="h6"
            gutterBottom
            style={{ textAlign: "center" }} // Added textAlign: "center"
          >
            <Link
              to="/AboutUs"
              style={{
                textDecoration: "none",
                color: "inherit",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              About Us
            </Link>
          </Typography>
        </Grid>

        {/* Copyright Section */}
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          sx={{
            backgroundColor: "white",
            color: "black",
            padding: "10px 20px",
            marginTop: "20px",
            "@media (max-width: 600px)": {
              fontSize: "0.8rem", // Adjust font size for smaller mobile screens
            },
          }}
        >
          <Grid item xs={12}>
            <div
              style={{
                width: "100%",
                height: "1px",
                backgroundColor: "gray",
                marginBottom: "10px",
              }}
            ></div>
          </Grid>

          {/* Left-aligned text */}
          <Grid item xs={12} sm={9}>
            <Typography
              variant="body2"
              align="left"
              sx={{
                color: "black",
                fontSize: "12px",
              }}
            >
              Copyright © {new Date().getFullYear()} All Rights Reserved. UK TO
              MARS Ltd is a company registered in England United Kingdom | 15
              Little Balmer, Buckingham Industrial Estate, MK18 1TF | Company
              Reg No: 15764998 | VAT No: 473487946
            </Typography>
          </Grid>

          {/* Right-aligned images */}
          {/* <Grid
            item
            xs={12}
            sm={3}
            display="flex"
            justifyContent="center"
            gap={2}
            sx={{
              marginLeft: "-10px",
            }}
          >
            <img src={Vise} alt="Visa" height={35} width={35} />
            <img src={Fib} alt="FIB" height={35} width={35} />
            <img src={MAster} alt="MasterCard" height={35} width={40} />
          </Grid>*/}
        </Grid>
      </Grid>
    </footer>
  );
};

export default Footer;
